import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../../../service/global.service';
import {ModalService} from '../../../service/modal.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {JQueryStatic} from 'jquery';


declare var $: JQueryStatic;

@Component({
    selector: 'app-roteiro-modal',
    templateUrl: './roteiro-modal.component.html',
    styleUrls: ['./roteiro-modal.component.css']
})
export class RoteiroModalComponent implements OnInit {

    constructor(
        private globalService: GlobalService,
        public modalService: ModalService,
        public pesquisaService: PesquisasFiltroApiService,
        public catalogoApi: CatalogoApiService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute) {
    }

    urlWikisRoteiro = 'https://banco365.sharepoint.com.mcas.ms/sites/IntegraoviaArquivos39/SitePages/BB-SIA---Roteiros-de-atendimento-gerados-pelo-sistema.aspx';
    sub: any;
    codFTA: any;
    vrsFTA: any;
    visiveis: any;
    resultado: any;
    totalPaginas: any;
    qtdPorPagina: any;
    msg: string;
    loading: any;

    ngOnInit() {
        this.sub = this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                if (params['codFTA'] != '') {
                    this.codFTA = params['codFTA'];
                }

                if (params['vrsFTA'] != '') {
                    this.vrsFTA = params['vrsFTA'];
                }


                this.pesquisar();
            });
    }

    refazerRoteiroAction(nr: number) {
        $(`.btn-nr-open`).hide();
        $(`.btn-nr-close`).show();
    }


    cotinuarRoteiroAction() {
        this.loading = true;
        this.visiveis = new Array<any>();
        this.resultado = new Array<any>();
        this.totalPaginas = 1;

        this.pesquisaService.gerarFtaRoteiro(this.codFTA, this.vrsFTA)
            .subscribe(
                rs => {
                    this.resultado = rs as Array<any>;
                    this.ajustarResultado();
                    this.totalPaginas = Math.ceil(rs.length / this.qtdPorPagina);
                    this.loading = false;
                },
                erro => {
                    this.loading = false;
                    if (erro.status == 404) {
                    }
                }
            );

        $(`.btn-nr-open`).show();
        $(`.btn-nr-close`).hide();
    }

    pesquisar() {
        this.loading = true;
        this.visiveis = new Array<any>();
        this.resultado = new Array<any>();
        this.totalPaginas = 1;

        this.pesquisaService.detalhaFtaRoteiro(this.codFTA, this.vrsFTA)
            .subscribe(
                rs => {
                    this.resultado = rs as Array<any>;

                    this.ajustarResultado();
                    this.totalPaginas = Math.ceil(rs.length / this.qtdPorPagina);
                    this.loading = false;
                },
                erro => {
                    this.loading = false;
                    if (erro.status == 404) {
                    }
                }
            );
    }

    ajustarResultado() {

        if (this.resultado != null) {
            switch (this.resultado.codEstadoRoteiro) {
                case 0:
                    this.msg = 'Concluído';
                    break;
                case 1:
                    this.msg = 'Pendente somente atividades do demandante';
                    break;
                case 2:
                    this.msg = 'Pendente atividades do demandante e do suporte';
                    break;
                case 3:
                    this.msg = 'Pendente somente atividades do suporte';
                    break;

            }

            if (this.resultado.steps != null) {
                this.resultado.steps.forEach((element, index) => {
                    if (element.instanciaResponsavelExecucao == 1) {
                        element.responsavel = 'Demandante';
                    } else {
                        element.responsavel = 'Suporte';
                    }
                    this.resultado.steps[index] = element;

                });
            }
        }
    }

    marcarExecutado(nr: any, index: any) {
        this.loading = true;
        this.resultado.steps[index].codFormaExecucao = -1;
        this.pesquisaService.marcaExecutadoFtaRoteiro(this.codFTA, this.vrsFTA, nr)
            .subscribe(
                rs => {
                    this.resultado = rs as Array<any>;
                    this.ajustarResultado();
                    this.exibirMensagem(rs.mensagemUltimaExecucaoStep, 'Sucesso!', 'green');
                    this.totalPaginas = Math.ceil(rs.length / this.qtdPorPagina);
                    this.loading = false;
                },
                erro => {
                    this.exibirMensagem(erro.error.mensagem, 'Erro', 'red');
                    this.loading = false;
                }
            );
    }

    exibirMensagem(msgTxt: string, tipo: string, color: string) {
        $.confirm({
            title: tipo,
            content: msgTxt,
            type: color,
            buttons: {
                ok: {
                    btnClass: 'btn-blue'
                }
            },
            onClose: () => {
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/roteiro-modal/roteiro-modal.component.ts